// extracted by mini-css-extract-plugin
module.exports = {"Label":"InputText_Label__2XJwy","Input":"InputText_Input__3-lL7","Border":"InputText_Border__2B9TK"};